import { Select, type SelectProps } from '@mantine/core'
import classes from './Dropdown.module.css'

export function Dropdown({ classNames, ...props }: SelectProps) {
  return (
    <Select
      classNames={{
        root: classes.root,
        input: classes.input,
        dropdown: classes.dropdown,
        option: classes.option,
        ...classNames,
      }}
      {...props}
    />
  )
}
